import type {
    IotApiClient,
    Nullable,
    PlatformStorage,
} from "@iot-platform/core";
import { coreTypes, PlatformStorageKeysEnum } from "@iot-platform/core";
import { inject, injectable, optional } from "inversify";

@injectable()
export class AuthenticationStorageDatasource {
    constructor(
        @inject(coreTypes.infrastructure.LocalStorage)
        private readonly persistentStorage: PlatformStorage,
        @inject(coreTypes.infrastructure.SessionStorage)
        @optional()
        private readonly sessionStorage: PlatformStorage | undefined,
        @inject(coreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
    ) {}

    getAccessToken(): Nullable<string> {
        // Try persistent first (for restore), then session
        return (
            this.persistentStorage.get(PlatformStorageKeysEnum.AccessToken) ??
            this.sessionStorage?.get(PlatformStorageKeysEnum.AccessToken) ??
            null
        );
    }

    saveAccessToken(accessToken: string, rememberSession = true): void {
        // Clear from both storages first
        this.persistentStorage.remove(PlatformStorageKeysEnum.AccessToken);
        this.sessionStorage?.remove(PlatformStorageKeysEnum.AccessToken);

        // Save to the appropriate storage
        const storage =
            rememberSession || !this.sessionStorage
                ? this.persistentStorage
                : this.sessionStorage;
        storage.set(PlatformStorageKeysEnum.AccessToken, accessToken);

        this.iotApiClient.enableAuth(accessToken);
    }

    deleteAccessToken(): void {
        this.persistentStorage.remove(PlatformStorageKeysEnum.AccessToken);
        this.sessionStorage?.remove(PlatformStorageKeysEnum.AccessToken);
    }
}
